var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/logo/logo-black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c(
            "main",
            {
              staticClass: "st-MainContents",
              staticStyle: { "padding-top": "120px" }
            },
            [
              _c("nav", { staticClass: "series-Nav sw-stickyTrigger-target" }, [
                _c(
                  "div",
                  { staticClass: "series-Nav_Inner series-Nav_Inner_company" },
                  [
                    _c("ul", { staticClass: "mb-0" }, [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/solution/logistics-automation" } },
                            [
                              _c("img", {
                                staticStyle: { "object-fit": "cover" },
                                attrs: {
                                  height: "50",
                                  width: "50",
                                  src: require("../../../../static/img/home/menu-logistics-automation.jpg"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("h4", { staticClass: "pl-md-4" }, [
                                _vm._v(
                                  "ロボティクス自動化ソリューション\n                  "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "current" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/solution/low-code" } },
                            [
                              _c("img", {
                                staticStyle: { "object-fit": "cover" },
                                attrs: {
                                  height: "50",
                                  width: "50",
                                  src: require("../../../../static/img/home/menu-low-code.jpg"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("h4", { staticClass: "pl-3 pl-md-4" }, [
                                _vm._v(
                                  "Lowコードソリューション\n                  "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("section", { staticClass: "company-Profile" }, [
                _c("div", { staticClass: "company-Profile_Inner pb-6" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "st-Grid_Inner p-0 solution-low-code-appear-1",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "common-text-appear text-center solution-low-code-appear-2",
                          attrs: { "data-appear": "true" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "sw-Section_Header-en pb-3" },
                            [
                              _c(
                                "b",
                                [
                                  _c(
                                    "font",
                                    [_c("font", [_vm._v("ES-FASTのご紹介")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(1)
                ])
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "company-Profile" }, [
                _c("div", { staticClass: "company-Profile_Inner pt-0 pb-5" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "st-Grid_Inner p-0 m-0 solution-low-code-appear-5",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "common-text-appear text-center solution-low-code-appear-6",
                          attrs: { "data-appear": "true" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "sw-Section_Header-en pb-6" },
                            [
                              _c(
                                "b",
                                [
                                  _c(
                                    "font",
                                    [_c("font", [_vm._v("ES-FASTの特徴")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(2)
                ])
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "company-Profile" }, [
                _c("div", { staticClass: "company-Profile_Inner pt-0 pb-6" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "st-Grid_Inner p-0 m-0 solution-low-code-appear-8",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "common-text-appear text-center solution-low-code-appear-9 appear",
                          attrs: { "data-appear": "true" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "sw-Section_Header-en pb-6" },
                            [
                              _c(
                                "b",
                                [
                                  _c(
                                    "font",
                                    [_c("font", [_vm._v("開発ツール搭載")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "fast-detail-body" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "fast-detail-column-text-appear swiper-container swiper-container-home-fast swiper-container-home-report-slide-3 common-appear solution-low-code-appear-10 p-0 appear",
                        attrs: { "data-appear": "" }
                      },
                      [
                        _c("div", { staticClass: "swiper-wrapper" }, [
                          _c("div", { staticClass: "swiper-slide" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "common-image-appear solution-low-code-appear-10-1 mt-5 appear",
                                attrs: { "data-appear": "true" }
                              },
                              [
                                _c("picture", [
                                  _c(
                                    "video",
                                    {
                                      attrs: {
                                        width: "100%",
                                        muted: "",
                                        autoplay: "",
                                        loop: "",
                                        playsinline: "",
                                        poster: ""
                                      },
                                      domProps: { muted: true }
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          src: require("../../../../static/video/es-editor.mp4"),
                                          type: "video/mp4"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(3)
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "swiper-slide" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "common-image-appear solution-low-code-appear-10-1 mt-5",
                                attrs: { "data-appear": "true" }
                              },
                              [
                                _c("picture", [
                                  _c(
                                    "video",
                                    {
                                      attrs: {
                                        width: "100%",
                                        muted: "",
                                        autoplay: "",
                                        loop: "",
                                        playsinline: "",
                                        poster: ""
                                      },
                                      domProps: { muted: true }
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          src: require("../../../../static/video/es-api.mp4"),
                                          type: "video/mp4"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(4)
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "swiper-slide" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "common-image-appear solution-low-code-appear-10-2 mt-5",
                                attrs: { "data-appear": "true" }
                              },
                              [
                                _c("picture", [
                                  _c(
                                    "video",
                                    {
                                      attrs: {
                                        width: "100%",
                                        muted: "",
                                        autoplay: "",
                                        loop: "",
                                        playsinline: "",
                                        poster: ""
                                      },
                                      domProps: { muted: true }
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          src: require("../../../../static/video/es-report.mp4"),
                                          type: "video/mp4"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(5)
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "swiper-slide" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "common-image-appear solution-low-code-appear-10-2 mt-5",
                                attrs: { "data-appear": "true" }
                              },
                              [
                                _c("picture", [
                                  _c(
                                    "video",
                                    {
                                      attrs: {
                                        width: "100%",
                                        muted: "",
                                        autoplay: "",
                                        loop: "",
                                        playsinline: "",
                                        poster: ""
                                      },
                                      domProps: { muted: true }
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          src: require("../../../../static/video/es-designer.mp4"),
                                          type: "video/mp4"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(6)
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._m(7),
                        _vm._v(" "),
                        _vm._m(8)
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "company-Profile" }, [
                _c("div", { staticClass: "company-Profile_Inner pt-0 pb-6" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "st-Grid_Inner p-0 m-0 solution-low-code-appear-11",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "common-text-appear text-center solution-low-code-appear-12",
                          attrs: { "data-appear": "true" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "sw-Section_Header-en pb-6" },
                            [
                              _c(
                                "b",
                                [
                                  _c(
                                    "font",
                                    [_c("font", [_vm._v("様々な課題解決")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(9)
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "st-Breadcrumbs" }, [
            _c("ul", { staticClass: "st-BreadcrumbsList" }, [
              _c(
                "li",
                { staticClass: "st-BreadcrumbsList_Item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "st-BreadcrumbsList_Item-link",
                      attrs: { to: "/" }
                    },
                    [
                      _c(
                        "p",
                        { attrs: { itemprop: "item", "aria-current": "page" } },
                        [
                          _c("span", { attrs: { itemprop: "name" } }, [
                            _vm._v("ホーム")
                          ])
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(10)
            ])
          ])
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "series-PageTitle" }, [
      _c(
        "div",
        { staticClass: "series-PageTitle_Inner", attrs: { "data-appear": "" } },
        [
          _c("h1", [
            _c("span", { staticClass: "series-PageTitle_Logo" }, [
              _vm._v("ES-FAST")
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "series-PageTitle_Title",
                staticStyle: { color: "#FFF" }
              },
              [_vm._v("Lowコードソリューション")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sw-parallax" }, [
            _c("div", { staticClass: "sw-parallax_outer js-parallax_outer" }, [
              _c("div", { staticClass: "sw-parallax_inner" }, [
                _c(
                  "div",
                  { staticClass: "sw-parallax_block js-parallax_block" },
                  [
                    _c("div", {
                      staticClass:
                        "sw-parallax_target promotion-PageTitle-visual",
                      staticStyle: {
                        background:
                          "url(../../../../static/img/solution/low-code/top.jpg) 50%/cover no-repeat",
                        top: "70px",
                        height: "480px"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fast-detail-body" }, [
      _c("div", { staticClass: "fast-detail-column" }, [
        _c(
          "div",
          { staticClass: "content-wrapper-home-fast st-grid-padding" },
          [
            _c(
              "div",
              {
                staticClass:
                  "common-image-appear solution-low-code-appear-3 mt-4",
                attrs: { "data-appear": "true" }
              },
              [
                _c("picture", [
                  _c("img", {
                    attrs: {
                      width: "100%",
                      src: require("../../../../static/img/solution/low-code/02.jpg")
                    }
                  })
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "top-card_Row-common solution-low-code-appear-4 pr-0 pl-0 col-md-6 p-0 mb-0",
            attrs: { "data-appear": "" }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "top-card_Row-text-common solution-low-code-appear-4",
                attrs: { "data-appear": "" }
              },
              [
                _c("div", { staticClass: "px-5 pt-4 pb-3 text" }, [
                  _vm._v(
                    "\n                      近年、DX推進の必要性が高まっていることで、Lowコード、Noコードという言葉をよく耳にするようになりました。"
                  ),
                  _c("br"),
                  _vm._v(
                    " \n                      弊社の製品ES-FASTは、そのLowコードを使用できるソリューション製品です。\n                      プログラミングの専門知識に詳しいIT人材がいなくても、 アプリケーションなどを簡単に作ることが可能です。\n                      基本業務機能を持ち、Lowコードで開発ができるツールも搭載しています。 \n                      柔軟かつ効率的に業務システムの構築ができ、業務シーンに合わせてお客様自身でもカスタマイズや機能追加ができます。 \n                      さらにタブレット、スマートフォンに適した画面も同時に構築が可能です。\n                    "
                  )
                ])
              ]
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fast-detail-body" }, [
      _c(
        "div",
        {
          staticClass:
            "fast-detail-column-text-appear swiper-container-home-fast swiper-container swiper-container-home-report-slide-1 common-appear solution-low-code-appear-7 p-0",
          attrs: { "data-appear": "" }
        },
        [
          _c("div", { staticClass: "swiper-wrapper" }, [
            _c("div", { staticClass: "swiper-slide" }, [
              _c("div", { staticClass: "fast-detail-column-text mt-3 pr-0" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-border-solution text-border-solution-slide-1 px-4 py-2"
                  },
                  [
                    _vm._v(
                      "\n                        基本の汎用機能を持ち、小規模な運用業務の"
                    ),
                    _c("br"),
                    _vm._v("システム化が簡単にできる\n                      ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "common-image-appear solution-low-code-appear-7-1 mt-4",
                  attrs: { "data-appear": "true" }
                },
                [
                  _c("picture", [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: require("../../../../static/img/solution/low-code/03.jpg")
                      }
                    })
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "swiper-slide" }, [
              _c("div", { staticClass: "fast-detail-column-text mt-3 pr-0" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-border-solution text-border-solution-slide-1 px-4 py-2"
                  },
                  [
                    _vm._v(
                      "\n                        Lowコード開発ツールを搭載し、柔軟かつ効率的に"
                    ),
                    _c("br"),
                    _vm._v("システムを構築できる\n                      ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "common-image-appear solution-low-code-appear-7-2 mt-4",
                  attrs: { "data-appear": "true" }
                },
                [
                  _c("picture", [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: require("../../../../static/img/solution/low-code/04.jpg")
                      }
                    })
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "swiper-slide" }, [
              _c("div", { staticClass: "fast-detail-column-text mt-3 pr-0" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-border-solution text-border-solution-slide-1 px-4 py-2"
                  },
                  [
                    _vm._v(
                      "\n                        PC、タブレット、スマートフォンなど多種多様なデバイスにGUIが適用され、多言語対応も可能\n                      "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "common-image-appear solution-low-code-appear-7-3 mt-4",
                  attrs: { "data-appear": "true" }
                },
                [
                  _c("picture", [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: require("../../../../static/img/solution/low-code/05.png")
                      }
                    })
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "swiper-button-next swiper-container-home-report-slide-1-next"
            },
            [_c("i", { staticClass: "icf el-icon-arrow-right" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "swiper-button-prev swiper-container-home-report-slide-1-prev"
            },
            [_c("i", { staticClass: "icf el-icon-arrow-left" })]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fast-detail-column-text mt-5 pr-0" }, [
      _c("div", { staticClass: "p-4" }, [
        _c("strong", { staticStyle: { "font-size": "1.7rem" } }, [
          _vm._v("ES-EDITORは")
        ]),
        _vm._v(
          "、フロントエンドのLowコード画面開発機能。ユーザがドラッグ&ドロップで画面設計や作成を行えるため、\n                        イニシャル工数の大幅削減や開発効率の向上ができるだけでなく、自社開発できることでランニング費用も最小限に抑えることができます。\n                      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fast-detail-column-text mt-5 pr-0" }, [
      _c("div", { staticClass: "p-4" }, [
        _c("strong", { staticStyle: { "font-size": "1.7rem" } }, [
          _vm._v("ES-APIは")
        ]),
        _vm._v(
          "、バックエンドのLowコードアプリケーション開発ツールです。DB連携はもちろんのこと、他システム連携も可視化ツールにより、簡単に実現が可能です。\n                      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fast-detail-column-text mt-5 pr-0" }, [
      _c("div", { staticClass: "p-4" }, [
        _c("strong", { staticStyle: { "font-size": "1.7rem" } }, [
          _vm._v("ES-REPORTは")
        ]),
        _vm._v(
          "、Lowコードを使った帳票作成ツールです。エクセルを編集するように簡単に使用でき、\n                        エクセルテンプレートからの作成も可能。さらにデータベースに接続し、マッピングにより簡単に帳票作成が可能です。\n                      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fast-detail-column-text mt-5 pr-0" }, [
      _c("div", { staticClass: "p-4" }, [
        _c("strong", { staticStyle: { "font-size": "1.7rem" } }, [
          _vm._v("ES-DESIGNERは")
        ]),
        _vm._v(
          "、GUIを通じて豊富なデザインテンプレートから、専門知識がなくても様々なフォーマットに合わせて簡単にパンフレット、名刺等コンテンツを作成するツールです。\n                      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "swiper-button-next swiper-container-home-report-slide-3-next"
      },
      [_c("i", { staticClass: "icf el-icon-arrow-right" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "swiper-button-prev swiper-container-home-report-slide-3-prev"
      },
      [_c("i", { staticClass: "icf el-icon-arrow-left" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fast-detail-body" }, [
      _c(
        "div",
        {
          staticClass:
            "fast-detail-column-text-appear swiper-container swiper-container-home-fast swiper-container-home-report-slide-2 common-appear solution-low-code-appear-13 p-0 appear",
          attrs: { "data-appear": "" }
        },
        [
          _c("div", { staticClass: "swiper-wrapper" }, [
            _c("div", { staticClass: "swiper-slide" }, [
              _c(
                "div",
                {
                  staticClass:
                    "common-image-appear solution-low-code-appear-13-1 mt-5 appear",
                  attrs: { "data-appear": "true" }
                },
                [
                  _c("picture", [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: require("../../../../static/img/solution/low-code/06.jpg")
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "fast-detail-column-text mt-5 pr-0" }, [
                _c("div", { staticClass: "p-4" }, [
                  _c("p", { staticClass: "title text-center" }, [
                    _vm._v("IT部門・保守担当者")
                  ]),
                  _vm._v(
                    "\n                        開発作業が標準化且つ可視化が可能となり、大幅に効率を向上できる。"
                  ),
                  _c("br"),
                  _vm._v(
                    "また、\n                        様々なシステム環境の構築を一元化することで、管理作業、運用保守が容易になる。\n                      "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "swiper-slide" }, [
              _c(
                "div",
                {
                  staticClass:
                    "common-image-appear solution-low-code-appear-13-1 mt-5",
                  attrs: { "data-appear": "true" }
                },
                [
                  _c("picture", [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: require("../../../../static/img/solution/low-code/07.jpg")
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "fast-detail-column-text mt-5 pr-0" }, [
                _c("div", { staticClass: "p-4" }, [
                  _c("p", { staticClass: "title text-center" }, [
                    _vm._v("業務部門・業務担当者")
                  ]),
                  _vm._v(
                    "\n                        プログラミングのスキルはいらず、ツールから簡単に\n                        ドラックアンドドロップで画面の追加、新規帳票の作成をすることができる。現場業務の集計、報告といった作業を簡易にすることが可能。\n                      "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "swiper-slide" }, [
              _c(
                "div",
                {
                  staticClass:
                    "common-image-appear solution-low-code-appear-13-1 mt-5",
                  attrs: { "data-appear": "true" }
                },
                [
                  _c("picture", [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: require("../../../../static/img/solution/low-code/08.jpg")
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "fast-detail-column-text mt-5 pr-0" }, [
                _c("div", { staticClass: "p-4" }, [
                  _c("p", { staticClass: "title text-center" }, [
                    _vm._v("経営部門・経営管理")
                  ]),
                  _vm._v(
                    "\n                        LowコードツールでDX対応が容易にでき、"
                  ),
                  _c("br"),
                  _vm._v(
                    "イニシャルとランニングコストも削減可能。\n                        IT人材不足により高騰する開発人件費を抑えるとともにシステムの内製化を実現することが可能。\n                      "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "swiper-button-next swiper-container-home-report-slide-2-next"
            },
            [_c("i", { staticClass: "icf el-icon-arrow-right" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "swiper-button-prev swiper-container-home-report-slide-2-prev"
            },
            [_c("i", { staticClass: "icf el-icon-arrow-left" })]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "st-BreadcrumbsList_Item" }, [
      _c("p", { attrs: { itemprop: "item", "aria-current": "page" } }, [
        _c("span", { attrs: { itemprop: "name" } }, [
          _vm._v("Lowコードソリューション")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2e5d51e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2e5d51e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/solution/low-code.vue
// module id = null
// module chunks = 